import { render } from "./FooterList.vue?vue&type=template&id=b223b82e"
import script from "./FooterList.vue?vue&type=script&lang=js"
export * from "./FooterList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__